import { TimePicker } from '@mui/x-date-pickers'
import cx from 'classnames'
import { format } from 'date-fns'
import { Controller, useFormContext } from 'react-hook-form'

type TimeFormat = `${string}:${string}`

interface FormDatePickerProps {
  name: string
  label: string
  timeFormat?: TimeFormat
  className?: string
  format?: string
}

export const FormTimePicker = ({
  name,
  label,
  timeFormat = 'HH:mm',
  className
}: FormDatePickerProps) => {
  const { control } = useFormContext()
  return (
    <div className={cx('FormTimePicker', className)}>
      <Controller
        name={name}
        control={control}
        render={({ field }) => {
          return (
            <TimePicker
              desktopModeMediaQuery='(min-width: 1200px)'
              closeOnSelect
              value={field.value && new Date(`1992-08-18T${field.value}`)}
              label={label}
              onChange={value => {
                if (value) {
                  field.onChange(format(new Date(value), timeFormat))
                }
              }}
              ampm={false}
            />
          )
        }}
      />
    </div>
  )
}
